"use client";

import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox";
import { RiCheckLine } from "@remixicon/react";
import { cn } from "cn";
import type { ComponentProps } from "react";

function Checkbox({ className, ...props }: CheckboxPrimitive.Root.Props) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer relative flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-input transition-colors outline-none group-has-disabled/field:opacity-50 group-has-[:focus-visible]/field-label:ring-0 group-has-[:focus-visible]/field-label:not-data-checked:border-input after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground group-has-[:focus-visible]/field-label:data-checked:border-primary dark:data-checked:bg-primary",
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none [&>svg]:size-3.5"
      >
        <RiCheckLine />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

/**
 * Неинтерактивный индикатор флажка: тот же вид, что у `Checkbox`, но без
 * поведения. Для плиток и кнопок, где состояние уже несёт сама кнопка
 * (`aria-pressed`): флажок внутри неё — рисунок, скрытый от диктора.
 * Переданные `children` заменяют галочку (например, буква на флажке).
 */
function CheckboxIndicator({
  checked,
  className,
  children,
  ...props
}: ComponentProps<"span"> & { checked: boolean }) {
  return (
    <span
      aria-hidden="true"
      data-slot="checkbox-indicator-box"
      data-checked={checked ? "" : undefined}
      className={cn(
        "relative flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-input transition-colors dark:bg-input/30 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary",
        className,
      )}
      {...props}
    >
      {children ?? (checked ? <RiCheckLine className="size-3.5" /> : null)}
    </span>
  );
}

export { Checkbox, CheckboxIndicator };
